import React, { Suspense } from 'react'
import { HashRouter } from 'react-router-dom'
import AppRoutes from './components/AppRoutes'
import './scss/style.scss'
import './scss/app.css'
import 'animate.css'
import 'react-datepicker/dist/react-datepicker.css'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const App = () => {
  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <AppRoutes />
      </Suspense>
    </HashRouter>
  )
}

export default App
